import React from 'react';
import { Typography, Button } from '@mui/material';
import PropTypes from 'prop-types';

import CustomModal from '~components/CustomModal';

import styles from './styles.module.scss';

function ConfirmNavigationModal({ isOpen, onConfirm, onCancel, title, message }) {
  return (
    <CustomModal isOpen={isOpen} onClose={onCancel} className={styles.confirmModal} hideCloseButton={false}>
      <div className={styles.modalContent}>
        <Typography variant="h6" className={styles.title}>
          {title || '¿Salir sin guardar?'}
        </Typography>
        <Typography variant="body1" className={styles.message}>
          {message || 'Se perderán los datos del pedido.'}
        </Typography>
        <div className={styles.actions}>
          <Button variant="outlined" color="primary" onClick={onCancel} className={styles.cancelButton}>
            Cancelar
          </Button>
          <Button variant="contained" color="error" onClick={onConfirm} className={styles.confirmButton}>
            Salir
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}

ConfirmNavigationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.string,
  title: PropTypes.string
};

export default ConfirmNavigationModal;
